import { Box, Typography } from "@mui/material";
import { NotFound } from "react-admin";
import { useNavigate } from "react-router-dom";
import HMLogo from "./layout/HMLogo";
const PageHeader = () => (
  <Box
    sx={{
      padding: 2,
      textAlign: "left",
      borderBottom: "7px solid #04983F",
      display: "flex",
      alignItems: "center",
      color: "gray",
    }}
  >
    Powered by <HMLogo />
  </Box>
);
const PageFooter = () => (
  <Box
    sx={{
      padding: 2,
      textAlign: "center",
      bottom: 0,
      left: 0,
      right: 0,
      position: "fixed",
      backgroundColor: "#f5f5f5",
      borderTop: "1px solid #e0e0e0",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <Typography variant="body2" sx={{ color: "gray" }}>
      Copyright Happy Mango {new Date().getFullYear()}
    </Typography>
  </Box>
);

const MyNotFoundPage = () => {
  const navigate = useNavigate();
  return (
    <>
      <Box
        sx={{
          width: "100vh",
          height: "100vh",
          padding: 2,
          textAlign: "center",
          minHeight: "500px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          margin: "auto",
        }}
      >
        <NotFound />
      </Box>
    </>
  );
};

export default MyNotFoundPage;
